export enum EUserPostQueryKey {
  PROJECT_POSTS = 'project-posts',
  AGENT_POSTS = 'agent-posts',
}
